import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IUnmatchedPushTotalBalanceDto } from '@/dtos';

import { UnappliedPushTotalBalance } from '../UnappliedFundsBanner.types';

const QUERY_KEY = 'useGetUnappliedPushTotalBalanceQuery';

interface Params {
  observedOrganizationId?: string;
  organizationId?: string;
  enabled?: boolean;
}

const useGetUnappliedPushTotalBalanceQuery = ({ observedOrganizationId, organizationId, enabled = true }: Params) => {
  const { data, isLoading } = useQuery(
    [QUERY_KEY, observedOrganizationId, organizationId],
    () =>
      organizationId
        ? api.get<IUnmatchedPushTotalBalanceDto>(API_URL.UNMATCHED_PUSH_TRANSACTIONS_TOTAL_BALANCE, {
            params: { organization_id: organizationId },
          })
        : api.get<IUnmatchedPushTotalBalanceDto>(API_URL.UNMATCHED_PUSH_TRANSACTIONS_TOTAL_BALANCE_AGGREGATED),
    { enabled }
  );

  const formattedData = useMemo<UnappliedPushTotalBalance>(
    () => ({
      amount: data?.data?.total_balance ?? 0,
      organizationNames: data?.data?.organization_names ?? [],
      organizationsCount: data?.data?.matched_organizations_count ?? 0,
    }),
    [data]
  );

  return { formattedData, isLoading };
};

export default useGetUnappliedPushTotalBalanceQuery;
